module.exports = __webpack_public_path__ + "img/MEDIA059.31009d88.jpg";